export interface IUserProfile{
    id: number;
    username: string;
    full_name:string;
    email:string;
    is_admin:boolean;
    token: number;
    type?: string;
}

export const defaultProfile:IUserProfile = {
    id: -1,
    username: "",
    full_name: "",
    email: "",
    is_admin: false,
    token: 0,
  };